import { render, staticRenderFns } from "./mian.vue?vue&type=template&id=66f73c9e&scoped=true&"
import script from "./mian.vue?vue&type=script&lang=ts&"
export * from "./mian.vue?vue&type=script&lang=ts&"
import style0 from "./mian.vue?vue&type=style&index=0&id=66f73c9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f73c9e",
  null
  
)

export default component.exports